import { LoyaltyModel, LoyaltyPayload } from './loyalty'

export interface ILoyaltyService {
  clear (): void
  fetch (): Promise<LoyaltyModel>
  update (payload: LoyaltyPayload): Promise<void>
}

export const LoyaltyServiceType = Symbol.for('ILoyaltyService')
